import { render, staticRenderFns } from "./ReportsGeneral.vue?vue&type=template&id=885f7748&"
import script from "./ReportsGeneral.vue?vue&type=script&lang=js&"
export * from "./ReportsGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ReportsGeneral.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReportsGeneral.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports